import { Box, Typography, Skeleton } from "@mui/material";
import { bytesConverter } from "../MemoryProgress/bytesConverter";

interface IDashboardStorageBreakdownItemProps {
  name?: string;
  icon?: React.ReactNode;
  usedSpace?: number;
  loading?: boolean;
}

export const DashboardStorageBreakdownItem = ({
  name,
  icon,
  usedSpace = 0,
  loading = false,
}: IDashboardStorageBreakdownItemProps) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignContent: "center",
      paddingBottom: "10px",
    }}
  >
    <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
      <Box
        width="24px"
        height="24px"
        sx={{ backgroundColor: "#e8eff3" }}
        display="flex"
        justifyContent="center"
        alignItems="center"
        borderRadius="2px"
      >
        {loading ? <Skeleton variant="circular" width={20} height={20} /> : icon}
      </Box>

      {loading ? (
        <Skeleton variant="text" width={100} height={20} />
      ) : (
        <Typography
          sx={{
            textAlign: "left",
            font: "normal normal normal 14px/21px Segoe UI",
            color: "#2D2D2D",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          {name}
        </Typography>
      )}
    </Box>

    {loading ? (
      <Skeleton variant="text" width={60} height={20} />
    ) : (
      <Typography
        sx={{
          textAlign: "left",
          font: "normal normal normal 14px/21px Segoe UI",
          color: "#2D2D2D",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >
        {bytesConverter(usedSpace)}
      </Typography>
    )}
  </Box>
);
